<template>
  <div class="background">
    <div class="bottom">
      <div class="text sans">
        <div class="title kl-title">ECCLL TOON</div>
        <div class="desc serif kl-description">
          기독교 세계관을 바탕으로 한<br>
          신박한 꿀잼 웹툰 공간, 에끌툰
        </div>
        <a href="https://www.eccll.com/" target="#">
          <img class="link" src="../assets/visit-ecclltoon.png" alt="">
        </a>
      </div>
    </div>
    <div class="bottom-image">
      <img src="../assets/bottom-characters.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
}
</script>


<style lang="scss" scoped>
.background {
  position: relative;
  background-color: #ffffff;
  .bottom {
    .text {
      padding-top: 140px;
      margin-left: 24px;
      text-align: right;
      padding-right: 52px;
      background: url('../assets/side-characters.png') left bottom no-repeat;
      background-size: 40%;
      .link {
        margin-top: 48px;
        height: 60px;
      }
      .title {
        font-weight: 500;
        letter-spacing: -4px;
        color: #262728;
      }
      .desc {
        letter-spacing: -3.5px;
        color: #262728;
      }
    }
  }
  .bottom-image {
    text-align: center;
    margin-top: 52px;
    img {
      width: 90%;
      margin: auto;
    }
  }
}
@media screen and (max-width: 640px) {
.background {
  .bottom {
    .text {
      padding-top: 70px;
      .link {
        margin-top: 16px;
        height: 40px;
      }
      .title {
        letter-spacing: -2.5px;
      }
      .desc {
        letter-spacing: -2px;
      }
    }
  }
  .bottom-image {
    text-align: center;
    margin-top: 32px;
    img {
      width: 90%;
      margin: auto;
    }
  }
}
}
</style>

